import React, { useState } from 'react';
import { UserCircle } from 'lucide-react';
import Toggle from '../../../components/ui/Toggle';
import { useError } from '../../../context/ErrorContext';

interface ClientDataSectionProps {
  requestGender: boolean;
  setRequestGender: (request: boolean) => void;
  requestBirthday: boolean;
  setRequestBirthday: (request: boolean) => void;
  requestEmail: boolean;
  setRequestEmail: (request: boolean) => void;
  clientLabel: string;
}

const ClientDataSection: React.FC<ClientDataSectionProps> = ({
  requestGender,
  setRequestGender,
  requestBirthday,
  setRequestBirthday,
  requestEmail,
  setRequestEmail,
  clientLabel
}) => {
  const { addError } = useError();
  const [saving, setSaving] = useState<boolean>(false);

  const handleToggleGender = () => {
    try {
      setSaving(true);
      setRequestGender(!requestGender);
    } catch (error) {
      addError(
        'No se pudo cambiar la configuración de género', 
        'validation', 
        'client-data-gender'
      );
      console.error('Error toggling gender setting:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleBirthday = () => {
    try {
      setSaving(true);
      setRequestBirthday(!requestBirthday);
    } catch (error) {
      addError(
        'No se pudo cambiar la configuración de cumpleaños', 
        'validation', 
        'client-data-birthday'
      );
      console.error('Error toggling birthday setting:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleEmail = () => {
    try {
      setSaving(true);
      setRequestEmail(!requestEmail);
    } catch (error) {
      addError(
        'No se pudo cambiar la configuración de correo electrónico', 
        'validation', 
        'client-data-email'
      );
      console.error('Error toggling email setting:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-surface-2 p-4 rounded-lg">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-medium text-content-2 flex items-center">
          <UserCircle className="h-5 w-5 mr-2 text-content-3" />
          Información del {clientLabel}
        </h4>
      </div>
      <p className="text-xs text-content-3 mt-1 mb-4">
        Selecciona qué información deseas recopilar de tus {clientLabel.toLowerCase()}s durante el proceso de registro.
      </p>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-sm font-medium text-content-2">Solicitar género del {clientLabel.toLowerCase()}</span>
          </div>
          <Toggle
            checked={requestGender}
            onChange={() => handleToggleGender()}
            disabled={saving}
            label="Solicitar género"
          />
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-sm font-medium text-content-2">Solicitar fecha de cumpleaños</span>
          </div>
          <Toggle
            checked={requestBirthday}
            onChange={() => handleToggleBirthday()}
            disabled={saving}
            label="Solicitar cumpleaños"
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-sm font-medium text-content-2">Solicitar correo electrónico</span>
          </div>
          <Toggle
            checked={requestEmail}
            onChange={() => handleToggleEmail()}
            disabled={saving}
            label="Solicitar email"
          />
        </div>
      </div>
    </div>
  );
};

export default ClientDataSection;